import React from 'react';
import HeroSection from '../components/HeroSection';
import '../App.css';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <>
          <Helmet>
        <title>Blackswift Inventories | Route-to-Market Southern Africa</title>
        <meta name="description" content="Blackswift Inventories provides integrated route-to-market, supply chain management, and brand stewardship across South Africa and Malawi." />
      </Helmet>

      <HeroSection 
        title="Your Trusted Route-to-Market Partner"
        subtitle="Deep local insight, integrated execution, and hands-on brand stewardship for sustainable growth in Southern Africa."
        buttonText="Explore Our Services"
        buttonLink="/services"
        backgroundImage="/hero-bg.jpg"   // <-- add your image path
        showIllustration={false}          // optional: hide the animation
      />
      
      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <h3>Southern Africa Distribution</h3>
              <p>Operating across South Africa and Malawi</p>
            </div>
            <div className="stat-card">
              <h3>Strategic Growth</h3>
              <p>Partnering with international manufacturers</p>
            </div>
            <div className="stat-card">
              <h3>Market Leadership</h3>
              <p>Building sustainable presence in Southern Africa</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section section-dark">
        <div className="container">
          <h2 className="text-center">Our Core Capabilities</h2>
          <div className="services-grid">
            <div className="service-card service-card-dark">
              <h3>Market Intelligence</h3>
              <p>Deep local insights and real-time market understanding to guide strategic decisions.</p>
            </div>
            <div className="service-card service-card-dark">
              <h3>Integrated Execution</h3>
              <p>Connecting commercial strategy, supply chain, and brand management into one disciplined system.</p>
            </div>
            <div className="service-card service-card-dark">
              <h3>Brand Stewardship</h3>
              <p>Hands-on responsibility for brand integrity, availability, and performance throughout the market lifecycle.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;